import * as Yup from "yup";

export const StockpileFormSchema = Yup.object().shape({
  sequenceNumber: Yup.number()
    .typeError("Stockpile number is required")
    .integer("Stockpile number must be a whole number")
    .min(1, "Stockpile number must be between 1 and 10")
    .max(10, "Stockpile number must be between 1 and 10")
    .required("Stockpile number is required"),
  status: Yup.string().required("Status is required"),
  capacity: Yup.number()
    .typeError("Capacity must be a number")
    .positive("Capacity must be greater than 0")
    .required("Capacity is required"),
});
